<template>
    <div>
        <div v-if="!bidderInstances || bidderInstances.length === 0" class="noInstance tableRowBorder">
            <span class="marginRight levelPlayIcon">
                <IconBase height="20" width="20" icon-name="levelPlayIcon"/>
            </span>
            <span class="font-6 noInstancesText">
                There are no active bidding sources
            </span>
            <a :href="activateBidderUrl" class="font-6 noInstancesLink">
                Activate Instances
            </a>
        </div>
        <div v-else>
            <div>
                <div class="tableRow tableHeader tableRowBorder">
                    <span class="font-6 tableText">
                        <span class="marginRight levelPlayIcon">
                            <IconBase height="20" width="20" icon-name="levelPlayIcon"/>
                         </span>
                        Bidding
                        <Tooltip :text="biddingTooltipText" v-once/>
                    </span>
                    <span class="font-6 tableHeaderMetric">eCPM</span>
                    <span class="font-6 tableHeaderMetric"> Imps. </span>
                    <span class="font-6 tableHeaderMetric">Revenue</span>
                    <span class="font-6 tableHeaderMetric">
                        SOV
                        <Tooltip text="SOV (share of voice) reflects this bidding instance's revenue share compared to
                         total revenue from both bidding and non-bidding ad source"/>
                    </span>
                </div>
                <BidderInstance class="tableRow tableDataRow tableRowBorder"
                                v-for="instance in bidderInstances"
                                :key="`${instance.providerId}_${instance.instanceId}`"
                                :provider-display-name="instance.providerDisplayName"
                                :ecpm="instance.eCPM || 0"
                                :impressions="instance.impressions || 0"
                                :revenue="instance.revenue || 0"
                                :sov="{ val: instance.sov, maxVal: maxSov}"
                                :appKey="appKey"
                                :missingConfiguration="instance.isMissingConfig"
                                :show-china-countries-tooltip="showChinaCountriesTooltip(instance)"
                                :activeCountries="instance.activeCountries"
                                :isAllCountries="instance.isAllCountries"
                />
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import consts from 'services/metaData/consts';
import getMaxValFromArray from 'services/utils/getMaxValFromArray';
import BidderInstance from './BidderInstance.vue';

export default {
    name: 'biddingTable',
    components: {
        IconBase, Tooltip, BidderInstance
    },
    data() {
        return {
            biddingTooltipText: 'Each bidding source provides a real time CPM bid for every ad impression opportunity.'
        };
    },
    props: {
        bidderInstances: {
            type: Array,
            required: true
        },
        appKey: String,
        groupHasChina: Boolean,
        maxSov: Number
    },
    computed: {
        activateBidderUrl() {
            return `/partners/monetize/mediation/setup/app/${this.appKey}`;
        }
    },
    methods: {
        showChinaCountriesTooltip({ providerId }) {
            return this.groupHasChina && providerId === consts.PROVIDER_IDS.FACEBOOK;
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .noInstance {
        line-height: 39px;

        .noInstancesText {
            color: $dark-300;
        }

        .noInstancesLink {
            color: $primary-500;
        }
    }

    .marginRight {
        margin-right: 8px;
    }

    .levelPlayIcon {
        line-height: 13px;
        vertical-align: middle;
    }

    .tableRow {
        display: grid;
        justify-content: space-between;
        grid-template-columns: 3fr 2.5fr 2.5fr 2.5fr 1.35fr;
    }

    .tableRowBorder {
        border-bottom: 1px solid $light-500;
    }

    .tableHeader {
        line-height: 40px;
    }

    .tableDataRow {
        line-height: 40px;
    }

    .tableText {
        color: $dark-300;
    }

    .tableHeaderMetric {
        color: $light-700;
    }

    .metricMargins {
        margin-left: 4px;
    }

</style>
